/**
 *
 * @module paywallClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class PaywallClientConfiguration
 * @extends ServiceClientConfiguration
 * @desc Provides configuration information used by the PaywallClient.
 *
 */
export default class PaywallClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/paywall/paywallClientConfiguration.js